import React from 'react';
import styled from 'styled-components';
import { removeUserFromGroup } from '../../../../api/groups/groups';
import { User } from '../../../../types/users/User';
import Button from '../../../atoms/Button/Button';
import Spinner from '../../../atoms/Spinner/Spinner';
import { useManagementTags } from '../../../../services/hooks/useTags';
import usePermissions from '../../../../services/hooks/usePermissions';
import CardBody from '../../../atoms/Card/CardBody';
import Card from '../../../atoms/Card/Card';
import Table from '../../../atoms/Table/Table';
import { ColumnDef } from '../../../atoms/Table/tableFeatures';
import { useGroupsStore } from '../../../../store/admin/groups/groupsStore';

interface Props {
    groupId: string;
    organizationId: string;
}

const UsersInGroup: React.FC<Props> = ({ groupId, organizationId }: Props) => {
    const { userManagementGroupTags } = useManagementTags();
    const { hasWrite } = usePermissions(userManagementGroupTags);

    const usersInGroup = useGroupsStore().groupListUsersResponse.data || [];
    const {
        fetchedUsersInGroup,
        removeUserFromGroupStarted,
        removeUserFromGroupSucceeded,
        removeUserFromGroupFailed,
    } = useGroupsStore();

    const onRemoveFromGroup = (e: React.MouseEvent<HTMLButtonElement>, id: string) => {
        e.stopPropagation();
        removeUserFromGroup(
            organizationId,
            id,
            groupId,
            removeUserFromGroupStarted,
            removeUserFromGroupSucceeded,
            removeUserFromGroupFailed
        );
    };

    const userColumns: ColumnDef<User>[] = [
        {
            header: 'Users',
            accessorKey: 'name',
        },
        {
            header: '',
            id: 'removeFromGroupId',
            accessorKey: 'id',
            meta: {
                style: {
                    textAlign: 'right',
                },
            },
            cell: (props: { row: { original: User } }) => {
                return (
                    <Button
                        onClick={e => onRemoveFromGroup(e, props.row.original.id)}
                        disabled={!hasWrite}
                    >
                        Remove from group
                    </Button>
                );
            },
        },
    ];

    return (
        <>
            {fetchedUsersInGroup ? (
                <Card>
                    <CardBody>
                        <Table<User> data={usersInGroup} columns={userColumns} />
                    </CardBody>
                </Card>
            ) : (
                <SpinnerContainer>
                    <Spinner text="Loading users in group" loading />
                </SpinnerContainer>
            )}
        </>
    );
};

const SpinnerContainer = styled.div`
    margin-top: 2rem;
`;

export default UsersInGroup;
